import { axiosInstance } from '../../api';
const BASE_PATH = '/cv_review';

//Get All CV Review group API Call
export let getAllCVReviewGroups = async () => {
    try {
        let value = await axiosInstance.get(BASE_PATH + '/get_assigned_cv_review_groups');
        return value;
    } catch (error) {
        return error
    }
}

//Get All CV Review grouped candidates API Call
export let getAllCVReviewGroupDetails = async (step_id) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_assigned_cv_reviews_by_group',{
            step_id: step_id
        });
        return value;
    } catch (error) {
        return error
    }
}


//Get Single CV Review Task Details API Call
export let getCVReviewTask = async (sessionID) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/get_cv_review_task', {
            session_id: sessionID
        })
        return value;
    } catch (error) {
        return error
    }
}

//Submit CV Review Task Details API Call
export let submitCVReviewTask = async (sessionID, userScore, commentsArray, overallRating) => {
    try {
        let value = await axiosInstance.post(BASE_PATH + '/submit_cv_review', {
            session_id: sessionID,
            score:userScore,
            comments:commentsArray,
            overallRating: overallRating
        })
        return value;
    } catch (error) {
        return error
    }
}